export default __webpack_public_path__ + "static/media/play.94c69b47.svg";